import React from 'react';

import './badge.scss';

interface BadgeProps {
  onClick: () => void;
}

const Badge: React.FC<BadgeProps> = ({ onClick, children }) => (
  <button type="button" onClick={onClick} className="badge">
    {children}
  </button>
);

export default Badge;
